import { createApi } from '@reduxjs/toolkit/query/react';
import { identity, pickBy } from 'lodash';

import { API_URL } from '../../../common/constants/api-url';
import { getBaseQuery } from '../base-query';
import { GetBrandsParams, GetBrandsResBody } from './brands-api-types';

export const brandsApiSlice = createApi({
  baseQuery: getBaseQuery({
    baseUrl: `${API_URL}`
  }),
  endpoints: (builder) => ({
    getBrands: builder.query<GetBrandsResBody, GetBrandsParams>({
      query: (params) => ({
        params: { limit: 100, offset: 0, ...pickBy(params, identity()) },
        url: '/admin/brands'
      }),
    })
  }),
  reducerPath: 'brands'
});
